/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IMarcas from 'Infotrack@Modelos/smartStock/marcas/entidades/marcas';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import MarcasCM from '../controladorModelo/marcasCM';
import { acciones, IEstadoMarcas } from '../reductorMarcas';
import MarcasVista from '../vista/tablaMarcasVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const marcasCM = new MarcasCM();

const TableMarcasCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [marcass, setMarcass] = React.useState<IMarcas[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoMarcas>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarMarcas();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarMarcas = () => {
        manejadorIndicadorCargaGlobal(true);
        marcasCM.consultarMarcasPorFiltro({EmpresaId:idEmpresa}).then((marcass) => {
            setMarcass(marcass);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadMarcas?: IMarcas) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadMarcas, tipoFormulario } });
    };

    const confirmarEliminacion = (marcas: IMarcas) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarMarcas(marcas),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarMarcas = (marcas: IMarcas) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        marcasCM.eliminarMarcas(marcas).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <MarcasVista
            marcass={marcass}
            cargarMarcas={cargarMarcas}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableMarcasCV;
